import Head from 'next/head';

import { pageTitle } from '../../components/shared/basic/customHead';
import ThankyouPage from '../../components/ThankyouPage';

const OrderSuccessfulPage = () => {
  return (
    <div>
      <Head>
        <title>{pageTitle('Order Successful')}</title>
      </Head>
      <div>
        <ThankyouPage />
      </div>
    </div>
  );
};

export default OrderSuccessfulPage;
